const pageSizeOptions = Array.from(
  { length: 20 },
  (_, index) => (index + 1) * 5,
);

export default pageSizeOptions;
